
<template>
  <div>
    <!-- 退票统计详情弹框开始 -->
    <el-dialog :close-on-click-modal="false"
      title="退票统计明细"
      :visible.sync="seeInfoVisible"
      :before-close="seeInfoHandleClose"
      width="65.4%"
      center
    >
      <el-divider></el-divider>
      <div class="titleZxtj">
        <el-input placeholder="请输入订单号" v-model="data1.ordernumber"></el-input>
        <div style="margin:0 1rem;"></div>

        <el-date-picker
          v-model="TpTime"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
        <div style="margin:0 1rem;"></div>

        <el-select v-model="data1.DistributorID" filterable placeholder="请选择分销商" clearable>
            <el-option
              v-for="item in Disoptions"
              :key="item.DistrbutorID"
              :label="item.Name"
              :value="item.DistrbutorID">
            </el-option>
        </el-select>
        <div style="margin:0 1rem;"></div>
        <el-select v-if="GetChannelFlow" v-model="data1.channelCode" clearable filterable placeholder="渠道商" >
          <el-option
            v-for="item in opstatusan"
            :key="item.channelCode"
            :label="item.channelName"
            :value="item.channelCode"
          ></el-option>
        </el-select>
        <div style="margin:0 1rem;"></div>

        <el-select v-model="data1.ProductID" filterable placeholder="请选择产品" clearable>
            <el-option
              v-for="item in Prooptions"
              :key="item.ProductID"
              :label="item.ProductName"
              :value="item.ProductID">
            </el-option>
        </el-select>
        <!-- <el-input v-model="data1.ordernumber" placeholder="请输入订单号"></el-input> -->
        <el-button @click="TpBtns">查询</el-button>
        <el-button class="Dcb" @click="xsexport">去导出</el-button>
      </div>
      <div>
        <el-table
          :data="tableData"
          style="width: 100%"
          v-loading="loading"
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
        >
          <el-table-column label="序号" type="index"></el-table-column>
          <!-- <el-table-column prop="Name" label="景区名称"></el-table-column> -->
          <el-table-column prop="ProductName" label="产品名称"></el-table-column>
          <el-table-column prop="OrdernNmber" label="订单号"></el-table-column>
          <el-table-column prop="UseTime" label="时间"></el-table-column>
          <el-table-column prop="Use" label="数量"></el-table-column>
          <el-table-column prop="CountPrice" label="销售额"></el-table-column>
        </el-table>
      </div>
      <!-- 分页开始 -->
      <div class="pagination">
        <span class="demonstration">共{{data1.total}}条记录，</span>
        <span class="demonstration">当前显示第{{data1.page}}页</span>
        <el-pagination background layout="prev, pager, next" :page-size="data1.page_size" :total="data1.total" @current-change="List"></el-pagination>
      </div>
      <!-- 分页结束 -->
    </el-dialog>
    <!-- 销售统计详情弹框结束 -->
    <!-- 消费统计详情弹框开始 -->
    <el-dialog :close-on-click-modal="false"
      title="消费统计明细"
      :visible.sync="detailVisible"
      :before-close="detailHandleClose"
      width="75.9%"
      center
      top="30vh"
    >
      <el-divider></el-divider>
      <div class="titleXstj">
        <el-input placeholder="请输入订单号" v-model="data2.OrderNumber"></el-input>
        <el-date-picker
          v-model="Times"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          value-format="yyyy-MM-dd"
          end-placeholder="结束日期"
        ></el-date-picker>
        <el-select v-model="data2.DistributorID" filterable placeholder="请选择分销商" clearable>
            <el-option
              v-for="item in Disoptions"
              :key="item.DistrbutorID"
              :label="item.Name"
              :value="item.DistrbutorID">
            </el-option>
        </el-select>
        <div style="margin:0 1rem;"></div>
        <el-select v-if="GetChannelFlow" v-model="data2.channelCode" clearable filterable placeholder="渠道商" >
          <el-option
            v-for="item in opstatusan"
            :key="item.channelCode"
            :label="item.channelName"
            :value="item.channelCode"
          ></el-option>
        </el-select>
        <div style="margin:0 1rem;"></div>
        <el-select v-model="data2.ProductID" filterable placeholder="请选择产品" clearable>
            <el-option
              v-for="item in Prooptions"
              :key="item.ProductID"
              :label="item.ProductName"
              :value="item.ProductID">
            </el-option>
        </el-select>
        <el-button @click="XfChaxun">查询</el-button>
        <el-button class="Dcb" @click="xfTable">去导出</el-button>
      </div>
      <div>
        <el-table
          :data="tableData"
          style="width: 100%"
          :header-cell-style="tableHeaderColor"
          v-loading="loading"
          :cell-style="cellStyle"
        >
          <el-table-column label="序号" type="index"></el-table-column>
          <el-table-column prop="ProductName" label="产品名称"></el-table-column>
          <el-table-column prop="OrdernNmber" label="订单号"></el-table-column>
          <el-table-column prop="CountPrice" label="金额"></el-table-column>
          <el-table-column prop="Use" label="验票数量"></el-table-column>
          <el-table-column  label="验票来源 ">
            <template slot-scope="scope">
              {{scope.row.from=='1'?'雪务通后台':scope.row.from=='2'?'内管':scope.row.from=='3'?'自助机':scope.row.from=='7'?'验票小程序':''}}
            </template>
          </el-table-column>
          <el-table-column prop="username" label="验票人"></el-table-column>
          <el-table-column prop="UseTime" label="验票时间"></el-table-column>
          <el-table-column  label="操作">
            <template slot-scope="scope">
                <span style="color:#409EFF;    cursor: pointer;" @click="hexiao(scope.row)">核销推送</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination">
        <span class="demonstration">共{{data2.total}}条记录，</span>
        <span class="demonstration">当前显示第{{data2.page}}页</span>
        <!--  -->
        <el-pagination background layout="prev, pager, next" :page-size="data2.page_size" :total="data2.total" @current-change="List1"></el-pagination>
      </div>
    </el-dialog>
    <!-- 消费统计详情框结束 -->
    <!-- 销售统计明细情弹框开始 -->
    <el-dialog :close-on-click-modal="false"
      title="销售统计明细"
      :visible.sync="refundTicketVisible"
      :before-close="refundTicketHandleClose"
      width="68.9%"
      center
      top="30vh"
    >
      <el-divider></el-divider>
      <div class="titleXstj xstksss">
        <el-date-picker
          v-model="data3Time"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          value-format="yyyy-MM-dd"
          end-placeholder="结束日期"
        ></el-date-picker>
        <el-select v-model="data3.DistributorID" filterable placeholder="请选择分销商" clearable>
            <el-option
              v-for="item in Disoptions"
              :key="item.DistrbutorID"
              :label="item.Name"
              :value="item.DistrbutorID">
            </el-option>
        </el-select>
        <div style="margin:0 1rem;"></div>
        <el-select v-model="data3.ProductID" filterable placeholder="请选择产品" clearable>
            <el-option
              v-for="item in Prooptions"
              :key="item.ProductID"
              :label="item.ProductName"
              :value="item.ProductID">
            </el-option>
        </el-select>
        <div style="margin:0 1rem;"></div>
        <el-select v-if="GetChannelFlow" v-model="data1.channelCode" clearable filterable placeholder="渠道商" >
          <el-option
            v-for="item in opstatusan"
            :key="item.channelCode"
            :label="item.channelName"
            :value="item.channelCode"
          ></el-option>
        </el-select>
        <div style="margin:0 1rem;"></div>
        <el-input v-model="data3.OrderNumber" placeholder="请输入订单号"></el-input>
        <div style="margin:0 1rem;"></div>
        <el-input v-model="data3.Mobile" placeholder="请输入手机号"></el-input>
        <el-button @click="XsChaxun">查询</el-button>
        <el-button class="Dcb" @click="XsTable">去导出</el-button>
      </div>
      <div>
        <el-table
          :data="tableData"
          style="width: 100%"
          v-loading="loading"
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
        >
          <el-table-column prop="OrderNumber" label="订单号"></el-table-column>
          <el-table-column label="产品名称">
            <template slot-scope="scope">
              {{scope.row.OrderAll.productname}}
            </template>
          </el-table-column>
          <el-table-column prop="OnlyCode" label="第三方订单号"></el-table-column>
          <el-table-column prop="OrderCode" label="消费码"></el-table-column>
          <el-table-column prop="Distributor_name" label="分销商名称"></el-table-column>
          <el-table-column prop="Mobile" label="手机号"></el-table-column>
          <el-table-column prop="CreateTime" label="下单时间" width="160"></el-table-column>
          <el-table-column prop="Count" label="数量"></el-table-column>
          <el-table-column prop="ComsumeFee" label="金额"></el-table-column>
        </el-table>
      </div>
      <div class="pagination">
        <span class="demonstration">共{{data3.total}}条记录，</span>
        <span class="demonstration">当前显示第{{data3.page}}页</span>
        <el-pagination background layout="prev, pager, next" :page-size="data3.page_size" :total="data3.total" @current-change="list3" ></el-pagination>
      </div>
    </el-dialog>
    <!-- 退票统计详情框结束 -->
  </div>
</template>

<script>
import {
  ScenicDisRefundTJXQ,
  getScenicListDistrbutor,
  GetScenicList,
  ScenicDisTicketTJXQ,
  ScenicDisTicketTJXQExport,
  RefundTJXQExport,
  ScenicDisSellOneTJ,
  getScenicOrderListNew,
  GetChannel,
  pushConsumeNotice
} from '@/request/scenic.js'
import {Message,MessageBox} from 'element-ui'
export default {
  props:['xstjinfoId','i','Tprow','starttime','xftjinfoId','fuTimes','times','dis','channelCode'],
  data() {
    return {
      opstatusan:[],
      seeInfoVisible: false, // 销售统计详情
      detailVisible: false, // 消费统计明细
      refundTicketVisible: false, // 退票统计明细
      tableData: [
      ],
      value1: "",
      options: [
      ],
      value: "",
      data1:{
        token:window.sessionStorage.getItem('Token'),
        start_date:'',
        end_date:'',
        productid:'',
        ordernumber:'',
        DistributorID:'',
        page_size:8,
        page:1,
        total:0,
        channelCode:'',
        ProductID:''
      },
      TpTime:'',
      loading:true,
      Disoptions:[
        {
          DistrbutorID:"a",
          Name:'景区直销' 
        }
      ],
      Prooptions:[],
      data2:{
        token:window.sessionStorage.getItem('Token'),
        start_date:'',
        end_date:'',
        ProductID:'',
        ordernumber:'',
        DistributorID:'',
        page_size:8,
        page:1,
        total:0,
        channelCode:''
      },
      Times:'',
      data3:{
        token:window.sessionStorage.getItem('Token'),
        start_date:'',
        end_date:'',
        DistributorID:'',
        ProductID:'',
        page_size:8,
        page:1,
        total:0,
        Mobile:'',
        OrderNumber:'',
        channelCode:''
      },
      data3Time:'',
      GetChannelFlow:false
    };
  },
  created(){
    if(window.sessionStorage.getItem('ScenicId')=='131'){
        this.GetChannelFlow = true
    }
    let datas = {
      token:window.sessionStorage.getItem('Token'),
    }
    GetChannel(datas).then(res=>{
      if(res.data.status=='ok'){
        this.opstatusan=res.data.result
      }
    })
    this.tableData = []
    this.Distor()
    this.ProList()
    this.data1.DistributorID = this.dis
    this.data2.DistributorID = this.dis
    this.data3.DistributorID = this.dis
    this.data1.channelCode = this.channelCode
    this.data2.channelCode = this.channelCode
    this.data3.channelCode = this.channelCode
    if(this.xstjinfoId||this.i==0){
      if(this.starttime){
        this.data1.start_date =this.starttime  + ' 00:00:00'  
        this.data1.end_date = this.starttime + ' 23:59:59'
        this.TpTime = [this.starttime,this.starttime]
      }else{
        this.data1.start_date = this.fuTimes[0]  + ' 00:00:00'  
        this.data1.end_date = this.fuTimes[1]  + ' 23:59:59'
        this.TpTime = this.fuTimes
      }
      this.data1.productid = this.xstjinfoId
      if(this.xstjinfoId){
        this.data1.ProductID = this.xstjinfoId
        console.log( this.data1.productid,321)
        this.data1.start_date =this.times[0] + ' 00:00:00'  
        this.data1.end_date = this.times[1]+ ' 23:59:59'
        this.TpTime = this.times
      }
      this.getListTp()
    }
    if(this.xftjinfoId||this.i==1){
      if(typeof this.starttime =='string'){
        this.data2.start_date = this.starttime + ' 00:00:00'
        this.data2.end_date = this.starttime  + ' 23:59:59'
        this.Times = [this.starttime,this.starttime]
      }else{
        this.data2.start_date = this.starttime[0] + ' 00:00:00'
        this.data2.end_date = this.starttime[1]  + ' 23:59:59'
        this.Times = this.starttime
      }
     
      if(this.xftjinfoId){
        this.data2.ProductID = this.xftjinfoId  
      }
      this.getListXf()
    }
    if(this.Tprow){
      if(this.Tprow.ProductID){
        this.data3.ProductID = this.Tprow.ProductID 
        this.data3.start_date = this.fuTimes[0] + ' 00:00:00'
        this.data3.end_date =this.fuTimes[1]   + ' 23:59:59'
        this.data3Time =  this.fuTimes
      }else{
        if(this.Tprow.statetype==1){
          this.data3.start_date = this.Tprow.CreateTime[0] + ' 00:00:00'
          this.data3.end_date = this.Tprow.CreateTime[1] + ' 23:59:59'
          this.data3Time = this.Tprow.CreateTime
        }else{
          this.data3.start_date = this.Tprow.CreateTime.substr(0,10) + ' 00:00:00'
          this.data3.end_date = this.Tprow.CreateTime.substr(0,10)   + ' 23:59:59'
          this.data3Time =  [this.Tprow.CreateTime.substr(0,10),this.Tprow.CreateTime.substr(0,10)]
        }
       
      }
      this.getListXs()
    }
  },
  methods: {
    hexiao(row){
      MessageBox(`同步第三方订单是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let data = {
          orderNumber:row.OrdernNmber,
          token:window.sessionStorage.getItem('Token'),
        }
        pushConsumeNotice(data).then(res=>{
          if(res.data.status=='ok'){
              Message.success('同步第三方订单成功')
            }else{
              Message.error(res.data.msg)
            }
        })
      }).catch(() => {
                
      });
    },
    xsexport(){
      if(this.data1.productid){
        this.data1.type='2'
      }else{
        this.data1.type='1'
      }
      this.$router.push({
        name:'report',
        params:{
            id:1,
            data:this.data1,
            index:'44'
        }
      })
    },
    //消费导出
    xfTable(){
      if(this.data2.ProductID){
        this.data2.type='2'
      }else{
        this.data2.type='1'
      }
      this.$router.push({
        name:'report',
        params:{
            id:1,
            data:this.data2,
            index:'55'
        }
      })
      // this.data2.page_size = 999
      // ScenicDisTicketTJXQExport(this.data2).then(res=>{
      //   if(res.data.status=='ok'){
      //     this.data2.page_size = 8
      //     window.location.href = res.data.result;
      //   }
      // })
    },
    // 销售导出
    XsTable(){
      if(this.data3.ProductID){
        this.data3.type='2'
      }else{
        this.data3.type='1'
      }
      this.data3.start_time =  this.data3.start_date
      this.data3.end_time =  this.data3.end_date
      this.$router.push({
        name:'report',
        params:{
            id:0,
            data:this.data3,
            index:'1523'
        }
      })
      // this.data3.page_size = 999
      // RefundTJXQExport(this.data3).then(res=>{
      //   if(res.data.status=='ok'){
      //     this.data3.page_size = 8
      //     window.location.href = res.data.result;
      //   }
      // })
    },

    list3(e){
      this.data3.page = e
      this.loading = true
      this.getListXs()
    },
    XsChaxun(){
      if(this.data3Time){
        this.data3.start_date =this.data3Time[0] + ' 00:00:00'
        this.data3.end_date =this.data3Time[1] + ' 23:59:59'
      }else{
        this.data3.start_date = ''
        this.data3.end_date = ''
        // Message.error('请选择时间')
        // return false
      }
      this.data3.total = 0
      this.data3.page = 1
      this.loading = true
      this.getListXs()
    },
    getListXs(){
      getScenicOrderListNew(this.data3).then(res=>{
        console.log(res)
        if(res.data.status=='ok'){
          this.tableData = res.data.result.data
          this.data3.total = res.data.result.total
          this.loading = false
        }
      })
    },


    List1(e){
      this.loading = true
      this.data2.page = e
      this.getListXf()
    },
    XfChaxun(){
      if(this.Times){
        this.data2.start_date = this.Times[0] + ' 00:00:00'
        this.data2.end_date = this.Times[1] + ' 23:59:59'
      }else{
        this.data2.start_date = ''
        this.data2.end_date = ''
        // Message.error('请选择时间')
        // return false
      }
      this.data2.page = 1
      this.data2.total = 0
      this.loading = true
      this.getListXf()
    },
    getListXf(){
      this.data2.ordernumber = this.data2.OrderNumber
      ScenicDisTicketTJXQ(this.data2).then(res=>{
        if(res.data.status=='ok'){
          this.tableData = res.data.result.data
          this.data2.total = res.data.result.total
          this.loading = false
        }
      })
    },



    // 获取分销商列表
    Distor(){
      let data = {
        token:window.sessionStorage.getItem('Token'),
        name:'',
        ProID:'',
        Status:'',
        page:1,
        page_size:999
      }
      getScenicListDistrbutor(data).then(res=>{
        if(res.data.status=='ok'){
          this.Disoptions = this.Disoptions.concat(res.data.result.data)
        }
      })
    },
    // 获取产品列表
    ProList(){
      let data = {
        token:window.sessionStorage.getItem('Token'),
        page:1,
        page_size:999
      }
      GetScenicList(data).then(res=>{
        if(res.data.status=='ok'){
          this.Prooptions = res.data.result.data
        }
      })
    },
    // 退票分页
    List(e){
      this.loading = true
      this.data1.page = e
      this.getListTp()
    },
    // 退票查询
    TpBtns(){
      if(this.TpTime){
        this.data1.start_date = this.TpTime[0] + ' 00:00:00'
        this.data1.end_date = this.TpTime[1] + ' 23:59:59'
      }else{
        this.data1.start_date = ''
        this.data1.end_date = ''
        // Message.error('请选择时间')
        // return false
      }
      this.loading = true
      this.data1.page = 1
      this.data1.total = 0
      this.getListTp()
    },
    // 退票列表
    getListTp(){
      ScenicDisRefundTJXQ(this.data1).then(res=>{
        if(res.data.status=='ok'){
          this.data1.total = res.data.result.total
          this.tableData = res.data.result.data
          this.loading = false
        }
      })
    },
    // 退票统计明细X
    refundTicketHandleClose() {
      this.refundTicketVisible = false;
      this.$emit('TpClose')
    },
    detailTick(row){
      this.refundTicketVisible = true
    },
    //消费统计明细
    Detail() {
      this.detailVisible = true;
    },
    //消费统计明细X
    detailHandleClose() {
      this.detailVisible = false;
      this.$emit('XFInfoHandle')
    },
    // 查看详情
    seeInfo(row) {
      this.seeInfoVisible = true;
      this.row = row
    },
    // 查看详情X
    seeInfoHandleClose() {
      this.seeInfoVisible = false;
      this.$emit('seeInfoHandle')
    },
    // 表头设置
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex
      });
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({
        row,
        rowIndex
      });
    }
  }
};
</script>

<style lang='less' scoped>
.titleXstj {
  display: flex;
  margin-bottom: 20px;
  flex-wrap:wrap ;
  .el-input {
    width: 250px;
    margin-bottom: 1rem;
  }
  .el-select {
    margin-bottom: 1rem;
    width: 220px;
  }
  /deep/.el-date-editor {
    margin-bottom: 1rem !important;
    margin: 0 20px;
  }
  .el-button {
    margin-bottom: 1rem;
    width: 100px;
    border: none;
    background: #246deb;
    border-radius: 4px;
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #ffffff;
    margin-left: 20px;
  }
  .Dcb {
    background: #ffffff;
    border: 1px solid #246deb;
    border-radius: 4px;
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #246deb;
    margin-bottom: 1rem;
    margin-left: 20px;
  }
}
.titleZxtj {
  margin-bottom: 20px;
  .el-button {
    width: 100px;
    border: none;
    background: #246deb;
    border-radius: 4px;
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #ffffff;
    margin-left: 20px;
  }
}
.btn {
  // margin: 20px 100px 10px 0;
  margin-top: 20px;
  margin-left: -100px;
  display: flex;
  justify-content: center;
  .el-button {
    width: 100px;
    height: 40px;
    background: #d9d9d9;
    border-radius: 4px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #ffffff;
    border: none;
  }
  .btnL {
    width: 100px;
    background: #246deb;
    border-radius: 4px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #ffffff;
  }
}
/deep/.el-form-item__label {
  font-family: "OPPOSans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  text-align: right;
  color: #666666;
}
/deep/.el-dialog__body {
  padding: 0px 20px 20px;
}

// 弹框标题设置
/deep/.el-dialog__title {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

/deep/.el-icon-close {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

// 分割线
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 0 0 20px 0;
}
// 分页
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  margin: 30px auto 20px;
  span {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
}

/deep/.el-pagination.is-background .el-pager li {
  margin: 0 5px;
  color: #000000;
  background: #ffffff;
  border: 1px solid #e5e5ea;
  border-radius: 2px;
  min-width: 32px;
}
/deep/.el-pager li {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  padding: 0 4px;
  background: #fff;
  min-width: 32px;
  height: 32px;
  line-height: 32px;
  box-sizing: border-box;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border: 1px solid #246deb;
  color: #246deb;
  background: white;
}

/deep/.el-pagination.is-background .btn-prev {
  color: #c0c4cc;
  height: 32px;
  min-width: 32px;
  background: white;
  border: 1px solid #e5e5ea;
}
/deep/.pagination .btn-prev .el-icon {
  display: block;
  font-size: 14px;
  font-weight: 700;
}

/deep/.el-pagination.is-background .btn-next {
  margin: 0 5px;
  background-color: white;
  color: #606266;
  min-width: 32px;
  height: 32px;
  border-radius: 2px;
  border: 1px solid #e5e5ea;
}
.titleZxtj{
  display: flex;
}
.titleZxtj .el-input{
  width: 200px;
}
.xstksss{
  ::v-deep .el-input,::v-deep .el-select{
    width: 16rem !important;
  }
  ::v-deep .el-date-editor{
    width: 27rem;
  }
}
</style>